import {
  ActionBar,
  ActionBarButtons,
  Column,
  CreateActionButton,
  List,
  Row,
  useApi,
} from "lcm-iot-commons";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { extractApiKeys } from "../../extractors/apiKeysExtractor";
import ApiKeyItem from "../ApiKeys/ApiKeyItem";
import { apiKeyShape } from "../../shapes/apiKeysShape";

type Props = Readonly<{
  clientApplicationId?: number;
  canUpdate?: boolean;
}>;

export default function ApiKeys(props: Props) {
  const api = useApi();
  const { id: subscriptionId } = useParams<{ id: string }>();
  const { clientApplicationId, canUpdate } = props;

  const { data: apiKeys } = api.get.useQuery(
    `/client_applications/${clientApplicationId}/api_keys`,
    null,
    {
      enabled: !!clientApplicationId,
      select: extractApiKeys,
    },
  );
  const targetUrl = `/subscriptions/connect/${subscriptionId}/api_keys/create`;

  return (
    <>
      <Row id="subscription-api-keys" className="space-before">
        <Column className="col-md-12">
          <ActionBar>
            <h2>
              <FormattedMessage id="subscription_details.api_keys.header" />
            </h2>
            <ActionBarButtons>
              <CreateActionButton
                // @ts-expect-error TS(2322) FIXME: Type '{ id: string; target: string; disabled: bool... Remove this comment to see the full error message
                id="create-api-key-button"
                target={targetUrl}
                disabled={!canUpdate}
              />
            </ActionBarButtons>
          </ActionBar>
        </Column>
      </Row>
      {apiKeys?.length > 0 ? (
        <List id="api-key-item-list">
          {apiKeys.map((apiKey: apiKeyShape) => (
            <ApiKeyItem key={apiKey.id} apiKey={apiKey} />
          ))}
        </List>
      ) : (
        <div id="no-api_keys-found">
          <FormattedMessage id="subscription_details.no_api_keys_assigned" />
        </div>
      )}
    </>
  );
}
